import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import JawsSegmentationApi from '../api/jawsSegmentationApi';
import { JawsSegmentationCreate, JawsSegmentationResponse } from '@/schema/jawsSegmentation';

// Get one segmentation by ID
export const useJawsSegmentation = (id: string, options?: { enabled?: boolean }) => {
  return useQuery<JawsSegmentationResponse>({
    queryKey: ['jawsSegmentation', id],
    queryFn: () => JawsSegmentationApi.getById(id),
    enabled: options?.enabled ?? Boolean(id),
  });
};

// Create a new segmentation (multipart)
export const useCreateJawsSegmentation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      data,
      upperJawGumModel,
      lowerJawGumModel,
      lowerJawTeethModels,
      upperJawTeethModels,
    }: {
      data: JawsSegmentationCreate;
      upperJawGumModel: Blob;
      lowerJawGumModel: Blob;
      lowerJawTeethModels: Blob[];
      upperJawTeethModels: Blob[];
    }) => JawsSegmentationApi.create(data, upperJawGumModel, lowerJawGumModel, lowerJawTeethModels, upperJawTeethModels),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jawsSegmentations'] });
    },
  });
};
